<template>
  <fragment>
    <slot name="header" />
    <FormSection class="pt-9" title="Dados Financeiros" v-if="userAreaIsGarantia">
      <v-col cols="12" md="4" class="pr-md-5">
        <BaseMoney
          id-element="valueCreditLimitModality"
          placeholder="Inserir Valor"
          label-text="Limite de Crédito"
          v-model="value.valor_limite_credito"
          required
          :rules="[requiredInput]"
          class="pb-6"
        />
      </v-col>
      <v-col cols="12" md="4" class="pr-md-5">
        <BaseMoney
          id-element="valuePolicyLimitModality"
          placeholder="Inserir"
          label-text="Limite por Apólice"
          v-model="value.valor_maximo_apolice"
          required
          :rules="[requiredInput]"
          class="pb-6"
        />
      </v-col>
      <v-col cols="12" md="4">
        <BaseMoney
          id-element="valueCCGLimitModality"
          placeholder="Inserir"
          label-text="Limite sem CCG"
          v-model="value.valor_sem_ccg"
          required
          :rules="[requiredInput]"
          class="pb-6"
        />
      </v-col>
    </FormSection>
    <v-divider />
    <FormSection class="pt-9" title="Taxas e comissões" v-if="userAreaIsGarantia">
      <v-col cols="12" md="4" class="pr-md-5">
        <BaseFormInput
          id-element="taxPercentageModality"
          placeholder="Inserir"
          label-text="Perc. Taxa"
          v-model="value.percentual_taxa"
          type="number"
          required
          :rules="[requiredInput]"
        />
      </v-col>
      <v-col cols="12" md="4">
        <BaseFormInput
          id-element="commissionPercentageModality"
          placeholder="Inserir"
          label-text="Perc. Comissão"
          v-model="value.percentual_comissao"
          type="number"
          required
          :rules="[requiredInput]"
        />
      </v-col>
    </FormSection>
    <v-divider />
    <FormSection class="pt-9" title="Regra Prêmio" v-if="userAreaIsGarantia">
      <v-col cols="12" class="py-5">
        <v-switch
          class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
          dense
          inset
          hide-details
          color="secondary"
          v-model="value.utiliza_valor_minimo_premio"
          @click="changeMinPrize"
        />
        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
          Utilizar prêmio mínimo
        </p>
      </v-col>
      <v-col cols="12" class="pt-2 pb-2" v-if="errorMessages.length > 0">
        <div class="v-text-field__details my-2">
          <div class="v-messages theme--light error--text" role="alert">
            <div class="v-messages__wrapper">
              <div
                v-for="(message, index) in errorMessages"
                :key="`error-message-${index}`"
                class="v-messages__message font-weight-bold"
              >
                {{ message }}
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="4" class="pr-md-5">
        <BaseMoney
          id-element="minValueModality"
          placeholder="Inserir Valor"
          label-text="Prêmio mínimo"
          v-model="value.valor_minimo_premio"
          required
          :disabled="!value.utiliza_valor_minimo_premio"
        />
      </v-col>
      <v-col cols="12" md="4" class="pr-md-5">
        <BaseFormSelect
          id-element="typePrizeValueModality"
          placeholder="Selecionar"
          v-model="value.tipo_regra_premio"
          required
          :rules="[requiredInput]"
          label-text="Modelo de Cálculo"
          :items="filterPrizeRules"
          item-text="nome"
          item-value="id"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" md="4" v-if="typeUnique">
        <BaseMoney
          id-element="prizeValueModality"
          placeholder="Inserir"
          label-text="Valor"
          v-model="value.valor_premio"
          required
          :error-messages="errorMessagesPrize"
          @change.native="validateMinPrize"
        />
      </v-col>
    </FormSection>
    <v-row>
      <v-col cols="12" class="mb-2" v-if="typeTable">
        <div class="configure-modality-form__table">
          <div class="pb-2" style="display: flex">
            <div class="pr-2">
              <div
                class="configure-modality-form__header configure-modality-form__header-insurance"
              >
                Valor Máximo da Importância segurada
              </div>
            </div>
            <div
              class="pr-2"
              v-for="(item, key) in value.tabela_premio.valores[0].prazos"
              :key="key"
            >
              <div
                class="configure-modality-form__header configure-modality-form__header-cover"
              >
                {{ headerTable(item) }}
              </div>
            </div>
          </div>
          <div
            v-for="(item, key) in value.tabela_premio.valores"
            :key="key"
            class="pb-2"
            style="display: flex"
          >
            <div class="pr-2">
              <money
                v-model="item.valor_importancia_segurada"
                v-bind="money"
                required
                @change.native="validateMinPrize"
                class="configure-modality-form__value configure-modality-form__value-insurance gray--text caption"
              />
            </div>
            <div
              class="pr-2"
              v-for="(element, index) in value.tabela_premio.valores[key]
                .prazos"
              :key="index"
            >
              <money
                v-model="item.prazos[index].valor_premio"
                v-bind="money"
                required
                @change.native="validateMinPrize"
                class="configure-modality-form__value configure-modality-form__value-cover gray--text caption"
              />
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="4" md="3" v-if="typeTable" class="py-5">
        <BaseButton
          class="secondary subtitle-2 font-weight-bold mb-10"
          width="100%"
          @click="tablePrizesModality(null)"
        >
          <v-icon class="pr-4 add-icon">fa-plus</v-icon>
          ADICIONAR LINHA
        </BaseButton>
      </v-col>
      <v-col cols="12" sm="4" md="3" v-if="typeTable" class="py-5">
        <BaseButton
          class="error subtitle-2 font-weight-bold mb-10 ml-10"
          width="100%"
          @click="tablePrizesModality('remove')"
        >
          <v-icon class="pr-4 add-icon">fa-minus</v-icon>
          REMOVER LINHA
        </BaseButton>
      </v-col>
    </v-row>
  </fragment>
</template>
<script>
import { mapState } from "vuex";
import FormSection from "@/components/FormSection.vue";
import { requiredInput } from "@/utils/rules.js";
import _ from "lodash";

export default {
  name: "ConfigureModalityForm",
  data: () => ({
    requiredInput,
    itemsCoverTime: [],
    filterPrizeRules: [],
    errorMessagesPrize: [],
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      suffix: "",
      precision: 2,
      masked: false /* doesn't work with directive */
    }
  }),
  components: { FormSection },
  computed: {
    ...mapState("me", ["userAreaIsGarantia"]),
    typeTable() {
      const differenceTimes =
        this.value.prazo_cobertura_ate - this.value.prazo_cobertura_de;
      return Boolean(
        this.value.tipo_regra_premio &&
          this.value.tipo_regra_premio.id == "tabela" &&
          this.value.prazo_cobertura_de &&
          this.value.prazo_cobertura_ate &&
          differenceTimes >= 0
      );
    },
    typeUnique() {
      return (
        this.value.tipo_regra_premio &&
        this.value.tipo_regra_premio.id == "unico"
      );
    },
    typePercentage() {
      return (
        this.value.tipo_regra_premio &&
        this.value.tipo_regra_premio.id == "percentual"
      );
    },
  },
  methods: {
    tablePrizesModality(action) {
      const differenceTimes =
        this.value.prazo_cobertura_ate - this.value.prazo_cobertura_de + 1;
      if (differenceTimes >= 0) {
        let items = _.times(differenceTimes, index => ({
          valor_premio: 0,
          prazo_em_anos: index + this.value.prazo_cobertura_de
        }));
        this.itemsCoverTime = items;
        if (action == "new") {
          this.value.tabela_premio.valores = [
            {
              valor_importancia_segurada: 0,
              prazos: items
            }
          ];
        } else if (action == "remove") {
          if (this.value.tabela_premio.valores.length > 1) {
            this.value.tabela_premio.valores.pop();
          }
        } else {
          this.value.tabela_premio.valores.push({
            valor_importancia_segurada: 0,
            prazos: items
          });
        }
      }
    },
    headerTable(item) {
      return `${item.prazo_em_anos}º ano de cobertura`;
    },
    validateMinPrize(event) {
      let originalValue = event.target.value;
      originalValue = originalValue.replace(/[^0-9.,]+/, "");
      originalValue = originalValue.replace(".", "").replace(",", ".");
      originalValue = Number(originalValue);

      if (this.value.utiliza_valor_minimo_premio) {
        this.errorMessagesPrize =
          originalValue >= this.value.valor_minimo_premio
            ? []
            : ["O valor deve ser maior, ou igual, ao prêmio mínimo"];
      }
    },
    changeMinPrize() {
      if (!this.value.utiliza_valor_minimo_premio) {
        this.value.valor_minimo_premio = 0;
      }
    }
  },
  props: {
    value: Object,
    submodality: Object,
    prizeRules: Array,
    errorMessages: Array
  },
  watch: {
    "value.prazo_cobertura_de"() {
      if (this.typeTable) this.tablePrizesModality("new");
    },
    "value.prazo_cobertura_ate"() {
      if (this.typeTable) this.tablePrizesModality("new");
    },
    "value.tipo_regra_premio"() {
      if (this.typeTable) this.tablePrizesModality("new");
    }
  },
  created() {
    this.value.valor_premio ??= 0;
    this.filterPrizeRules = this.prizeRules.filter(prizeRule => {
      if (prizeRule.id !== "tabela") return true;

      return (
        this.value.submodalidade &&
        this.value.submodalidade.id === "judicial_recursal"
      );
    });
  }
};
</script>
<style lang="sass">
.configure-modality-form__
  &header
    border: 1px solid #D5D5E0
    border-radius: 4px
    background-color: #F0F0F7
    height: 50px
    padding: 7px 15px
    color: #232633
    font-size: 14px
    font-weight: 600
    line-height: 16px
    line
    &-insurance
      width: 210px !important
      min-width: 210px !important
    &-cover
      width: 150px !important
      min-width: 150px !important
  &value
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #FFFFFF
    height: 40px
    padding: 12px 15px
    fieldset
      border: 0 !important
    &-insurance
      width: 210px !important
      min-width: 210px !important
    &-cover
      width: 150px !important
      min-width: 150px !important
  &table
    overflow-x: auto
</style>
